/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 13/01/2021
 */

import * as SessionUtils from '@/core/session_utils.js'

const cart3Request = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        cart3: null,
    }
}

export default cart3Request;